import {IData} from '../interfaces/reducers'
import {IPaylodAction} from '../interfaces/dispatchers'
import DataActions from '../enums/ActionTypes/DataActions'

const initState: IData = {featureTables: {}, visibleTables: {}, loading: false}

const data = (state: IData = initState, action: IPaylodAction): IData => {
  switch (action.type) {
    //TABLES
    case DataActions.SET_TABLES_EMPTY:
      return {...state, featureTables: {}}
    case DataActions.UPDATE_SELECTIONS:
      return {
        ...state,
        featureTables: {
          ...state.featureTables,
          [action.payload.tableId]: {
            ...state.featureTables[action.payload.tableId],
            selectedIds: action.payload.selectedIds
          }
        }
      }
    case DataActions.UPDATE_EXPANDED:
      return {
        ...state,
        featureTables: {
          ...state.featureTables,
          [action.payload.tableId]: {...state.featureTables[action.payload.tableId], expanded: action.payload.expanded}
        }
      }
    case DataActions.SET_TABLE_INFOS:
      return {...state, featureTables: {...action.payload}}
    case DataActions.ADD_QUERY_SYNC_TABS:
    case DataActions.ADD_ASYNC_TABS:
    case DataActions.SEND_LOADING_TABLES:
    case DataActions.UPDATE_QUERY_SYNC_TABS:
    case DataActions.ADD_SYNC_TABS:
    case DataActions.SUBSCRIBE_TO_MAP:
    case DataActions.UNSUBSCRIBE_TO_MAP:
      return {...state, featureTables: {...state.featureTables, ...action.payload}}
    case DataActions.SET_LOADING:
      return {...state, loading: action.payload}
    case DataActions.SET_TABLES_VISIBILITY:
      return {...state, visibleTables: {...action.payload}}

    //SingleView
    case DataActions.SET_SINGLE_VIEW_SELECTED_FEATURE:
      return {...state, singleViewSelectedFeature: {...action.payload}}
    case DataActions.REMOVE__SINGLE_VIEW_SELECTED_FEATURE:
      return {...state, singleViewSelectedFeature: undefined}

    //SingleCreate
    case DataActions.SET_SINGLE_CREATE_SELECTED_FEATURE:
      return {...state, singleCreateSelectedFeature: {...action.payload}}
    case DataActions.REMOVE_SINGLE_CREATE_SELECTED_FEATURE:
      return {...state, singleCreateSelectedFeature: undefined}

    default:
      return state
  }
}
export default data
